module.exports = __webpack_public_path__ + "img/convenioSindical1.7ee4f1c4.jpg";